import { render, staticRenderFns } from "./CommitNotes.vue?vue&type=template&id=5d355367&"
import script from "./CommitNotes.vue?vue&type=script&lang=js&"
export * from "./CommitNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports